// src/App.js — DR-Aura ULTIMATE v3.0
import React, { lazy, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ConsentBanner from './components/ConsentBanner';
import { PageLoader } from './components/Loader';
import './styles/global.css';
import './styles/premiumTheme.css';

const AppRoutes = lazy(() => import('./routes'));

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Navbar />
          <main id="main-content" style={{ flex: 1 }}>
            <Suspense fallback={<PageLoader />}>
              <AppRoutes />
            </Suspense>
          </main>
          <Footer />
        </div>
        <ConsentBanner />
        <Toaster
          position="bottom-right"
          containerStyle={{ bottom: 80 }}
          toastOptions={{
            style: {
              background: 'var(--surface, #1e150a)',
              color: 'var(--text-primary, #f5ede0)',
              border: '1px solid var(--border-strong, rgba(201,151,26,0.4))',
              borderRadius: 'var(--radius-md, 12px)',
              fontFamily: "'Space Grotesk', system-ui, sans-serif",
              fontSize: '0.88rem',
              boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
              maxWidth: 360,
            },
            success: { iconTheme: { primary: '#e8b834', secondary: '#0a0603' }, duration: 3000 },
            error:   { iconTheme: { primary: '#e74c3c', secondary: '#fff' },    duration: 4000 },
            loading: { iconTheme: { primary: '#c9971a', secondary: '#0a0603' } },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
